type Props = {
  current: number;
  total: number;
  onChange: (page: number) => void;
};

export default function Pagination({ current, total, onChange }: Props) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center flex-wrap gap-2 mt-8">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="whitespace-nowrap inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-background-300 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
            p === current
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-800"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="whitespace-nowrap inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-background-300 text-sm text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}